<template>
  <div class="col-sm-2 text-center"
    style="margin-bottom: 1rem;"
  >
    <div :class="isDraging ? 'dropin' : ''" style="height: 90px;"
      @dragleave="isDraging = false"
      @drop="dropFileInFolder"
      @dragover="cancelDefaultHandling"
    >
      <i class="fa fa-folder"
        @click="$emit('openGeneralUploadModal', folder)"
      ></i>
      <br>
      {{ folder.name }} <span v-if="folder.documents.length">({{ folder.documents.length }})</span>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: ['folder'],
    data() {
      return {
        isDraging: false,
      }
    },
    computed: {
      ...mapState(['drag']),
    },
    methods: {
      checkIfDraging() {
        if (this.drag) {
          this.isDraging = true
        }
      },
      dropFileInFolder() {
        if (this.isDraging) {
          this.$store.dispatch('storeDocumentInFolder', this.folder).then(() => this.isDraging = false)
        }
      },
      cancelDefaultHandling(event) {
        event.preventDefault()
        this.checkIfDraging()
        event.dataTransfer.dropEffect = "link";
      }
    },
  }
</script>

<style lang="scss" scoped>
@import '~@/_variables.scss';

.fa-folder {
  font-size: 3em;
  cursor: pointer;
  color: $kodak-red;
}
.dropin .fa-folder {
  font-size: 3.5em;
  color: $kodak-yellow;
}
</style>




// WEBPACK FOOTER //
// resources/js/components/FolderElement.vue